import * as actions from './Actions.js';

import { Col, Row } from 'react-bootstrap';
import {
  PARAM_DEMONSTRA_CONTRATO_VIGENTES_POR_PADRAO,
  PARAM_NAO_FILTRAR_CONTRATO_EXERCICIO_PADRAO
} from 'portaltransparencia-common/parametros/ParametrosPortalTransparencia.js';
import {
  addFilterUrl,
  addPagination
} from 'portaltransparencia-common/libs/AddFilter.js';
import {
  onChange,
  resetCrud
} from 'portaltransparencia-common/crud/Actions.js';

import Component from 'react-pure-render/component';
import ContratoListagem from './ContratoListagem.react.js';
import DatePicker from 'portaltransparencia-common/components/DatePicker.react.js';
import DateUtils from 'portaltransparencia-common/libs/DateUtils.js';
import ExportButtonGroup from 'portaltransparencia-common/components/ExportButtonGroup.react.js';
import FilterButtons from '../components/FilterButtons.react';
import Input from 'portaltransparencia-common/components/EloInput.react.js';
import { Map } from 'immutable';
import NotasExplicativas from '../notaexplicativa/Form.react';
import PageHeader from '../components/PageHeader.react.js';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import PropTypes from 'prop-types';
import React from 'react';
import SearchPagination from 'portaltransparencia-common/components/SearchPagination.react.js';
import StorageService from 'portaltransparencia-common/libs/StorageService.js';
import UltimaAtualizacao from '../ultimaatualizacao/Form.react.js';
import { addErrorNotification } from 'portaltransparencia-common/ui/Actions.js';
import configuration from 'portaltransparencia-common/config/Config.js';
import { connect } from 'react-redux';
import { downloadArquivo } from '../arquivo/Actions.js';
import { loadModalidades } from '../licitacoes/Actions.js';

const contractSectionTitleStyle = {
  marginTop: 20
};

const optionCheckboxStyle = {
  paddingTop: 14
};

const periodFilterStyles = {
  block: {
    marginBottom: 10
  },
  title: {
    display: 'block',
    marginBottom: 0
  },
  range: {
    alignItems: 'flex-end',
    display: 'flex',
    marginLeft: -6,
    marginRight: -6
  },
  field: {
    flex: '1 1 0',
    float: 'none',
    paddingLeft: 6,
    paddingRight: 6,
    width: 'auto'
  },
  separator: {
    alignItems: 'center',
    color: '#5d5d5d',
    display: 'flex',
    flex: '0 0 auto',
    float: 'none',
    justifyContent: 'center',
    minHeight: 38,
    padding: '10px 4px 0',
    width: 'auto'
  },
  separatedBlock: {
    borderLeft: '1px solid #eeeeee',
    marginBottom: 10
  }
};

export class FormContrato extends Component {
  static propTypes = {
    page: PropTypes.object.isRequired,
    downloadArquivo: PropTypes.func.isRequired,
    searchContratos: PropTypes.func.isRequired,
    loadTiposContrato: PropTypes.func.isRequired,
    tiposContrato: PropTypes.object.isRequired,
    loadModalidades: PropTypes.func.isRequired,
    tiposLicitacao: PropTypes.object,
    filtros: PropTypes.object,
    onChange: PropTypes.func,
    location: PropTypes.object.isRequired,
    resetCrud: PropTypes.func.isRequired,
    uf: PropTypes.string,
    isIntegradoOxy: PropTypes.bool,
    addErrorNotification: PropTypes.func.isRequired,
    parametroGeralCurrent: PropTypes.object,
    findParametrosPadraoExercicio: PropTypes.func,
    parametrosPadraoExercicio: PropTypes.object
  };

  state = {
    carregouTiposContrato: false
  };

  async carregarTiposContratos() {
    const { uf, loadTiposContrato } = this.props;
    const { carregouTiposContrato } = this.state;
    if (carregouTiposContrato || !uf) {
      return;
    }
    this.setState({ carregouTiposContrato: true });
    return loadTiposContrato(uf);
  }

  componentDidMount() {
    const { loadModalidades, page, findParametrosPadraoExercicio } = this.props;
    let userInfo = StorageService.getItem('userInfo');
    const { entidade } = userInfo;
    this.carregarTiposContratos().then(() => this.searchWithPage(page));
    loadModalidades();
    this.loadInitialFiltros();
    findParametrosPadraoExercicio(entidade.id);
  }

  componentDidUpdate(prevProps) {
    const { carregouTiposContrato } = this.state || {};
    const { uf: oldUf } = prevProps || {};
    const { uf, page } = this.props;
    if (!carregouTiposContrato || uf !== oldUf) {
      this.setState({ carregouTiposContrato: false });
      this.carregarTiposContratos().then(() => this.searchWithPage(page));
    }
    if (
      this.props.parametrosPadraoExercicio?.size !=
      prevProps.parametrosPadraoExercicio?.size
    ) {
      this.renderPadraoExercicio();
    }
  }

  loadInitialFiltros = () => {
    const { onChange, filtros } = this.props;
    const { exercicio } = StorageService.getItem('userInfo');
    const exercicioContrato = filtros.get('exercicioContrato');

    if (filtros.get('exercicioContrato') === undefined) {
      onChange('filtroContratos', {
        name: 'exercicioContrato',
        value: `${exercicio.id}`
      });
    }

    if (filtros.get('contratosVigentes') === undefined) {
      onChange('filtroContratos', {
        name: 'contratosVigentes',
        value: true
      });
    }
  };

  onChangeFiltro = event => {
    const { onChange } = this.props;

    onChange('filtroContratos', event);
  };

  showRateio = () =>
    !(this.props.uf === 'PR') ||
    !this.props.tiposContrato?.filter(obj => obj.get('sigla') === 'RA').size;

  onResetFiltro = () => {
    const {
      resetCrud,
      searchContratos,
      parametrosPadraoExercicio
    } = this.props;
    resetCrud('filtroContratos');
    let userInfo = StorageService.getItem('userInfo');
    const { entidade, exercicio } = userInfo;

    const naoFiltrarExercicio =
      parametrosPadraoExercicio &&
      parametrosPadraoExercicio.find(
        p =>
          p.getIn(['id', 'id']) ===
            PARAM_NAO_FILTRAR_CONTRATO_EXERCICIO_PADRAO &&
          p.get('valor') === 'S'
      );

    let filter = `entidade=${entidade.id}`;
    if (!naoFiltrarExercicio) {
      filter += `&exercicio=${exercicio.id}`;
    }

    searchContratos(filter);
  };

  renderTiposContrato = (data, key) => {
    const { isIntegradoOxy } = this.props;
    const value = data.get(
      isIntegradoOxy ? 'tipoContrato' : 'siglaTipoContrato'
    );
    const descricao = data.get('tipoContrato');
    return (
      <option key={key} value={value}>
        {descricao}
      </option>
    );
  };

  renderTiposLicitacao = data => {
    return (
      <option key={data.get('id')} value={data.get('id')}>
        {data.get('id') + ' - ' + data.get('descricao')}
      </option>
    );
  };

  renderPadraoExercicio = () => {
    const { parametrosPadraoExercicio } = this.props;
    if (parametrosPadraoExercicio) {
      const parametrosPreenchidos = parametrosPadraoExercicio.filter(
        parametro => parametro.get('valor') !== ''
      );
      parametrosPreenchidos.map(parametro => {
        switch (parametro.get('id').get('id')) {
          case PARAM_NAO_FILTRAR_CONTRATO_EXERCICIO_PADRAO:
            if (parametro.get('valor') === 'S') {
              this.props.onChange('filtroContratos', {
                name: 'exercicioContrato',
                value: ''
              });
            }
            break;
          case PARAM_DEMONSTRA_CONTRATO_VIGENTES_POR_PADRAO:
            if (parametro.get('valor') != 'S') {
              this.props.onChange('filtroContratos', {
                name: 'contratosVigentes',
                value: ''
              });
            }
            break;
          default:
            break;
        }
      });
    }
  };

  onConsultaContratos = event => {
    const { page } = this.props;

    const initialPage = page.set('number', 0);

    this.searchWithPage(initialPage);

    event && event.preventDefault();
    this.refs.panelFiltroContratos && this.refs.panelFiltroContratos.collapse();
  };

  searchWithPage = page => {
    const { searchContratos } = this.props;

    const filter = this.montaFiltro(page);

    searchContratos(filter);
  };

  addFilter = function (actualFilter, filterAnd) {
    let filterOperator = '';
    if (actualFilter !== '') {
      filterOperator = '&';
    }
    return actualFilter + filterOperator + filterAnd;
  };

  montaFiltro = function (page) {
    let userInfo = StorageService.getItem('userInfo');
    const { entidade, exercicio } = userInfo;
    const { filtros } = this.props;
    let filter = `entidade=${entidade.id}`;
    if (filtros.get('exercicioContrato')) {
      filter = this.addFilter(
        filter,
        `&exercicio=${filtros.get(
          'exercicioContrato'
        )}&exercicioContrato=${filtros.get('exercicioContrato')}`
      );
    }
    if (this.refs.tipoContrato && this.refs.tipoContrato.getValue()) {
      filter = this.addFilter(
        filter,
        `tipoContrato=${this.refs.tipoContrato.getValue()}`
      );
    }
    if (this.refs.numeroContrato && this.refs.numeroContrato.getValue()) {
      filter = this.addFilter(
        filter,
        `numeroContrato=${this.refs.numeroContrato.getValue()}`
      );
    }
    if (this.refs.tipoAto && this.refs.tipoAto.getValue()) {
      filter = this.addFilter(
        filter,
        `tipoAto=${this.refs.tipoAto.getValue()}`
      );
    }
    if (this.refs.tipoLicitacao && this.refs.tipoLicitacao.getValue()) {
      filter = this.addFilter(
        filter,
        `tipoLicitacao=${this.refs.tipoLicitacao.getValue()}`
      );
    }
    if (this.refs.numeroLicitacao && this.refs.numeroLicitacao.getValue()) {
      filter = this.addFilter(
        filter,
        `numeroLicitacao=${this.refs.numeroLicitacao.getValue()}`
      );
    }
    if (this.refs.nome && this.refs.nome.getValue()) {
      filter = this.addFilter(filter, `nome=${this.refs.nome.getValue()}`);
    }
    if (
      filtros.get('dataInicialAssinatura') &&
      filtros.get('dataInicialAssinatura').length == 10
    ) {
      let validValue = DateUtils.transform(
        filtros.get('dataInicialAssinatura'),
        'yy-mm-dd',
        'yy-mm-dd'
      );
      filter = addFilterUrl(filter, `dataInicialAssinatura=${validValue}`);
    }
    if (
      filtros.get('dataFinalAssinatura') &&
      filtros.get('dataFinalAssinatura').length == 10
    ) {
      let validValue = DateUtils.transform(
        filtros.get('dataFinalAssinatura'),
        'yy-mm-dd',
        'yy-mm-dd'
      );
      filter = addFilterUrl(filter, `dataFinalAssinatura=${validValue}`);
    }
    if (
      filtros.get('dataInicialInicioVigencia') &&
      filtros.get('dataInicialInicioVigencia').length == 10
    ) {
      let validValue = DateUtils.transform(
        filtros.get('dataInicialInicioVigencia'),
        'yy-mm-dd',
        'yy-mm-dd'
      );
      filter = addFilterUrl(filter, `dataInicialInicioVigencia=${validValue}`);
    }
    if (
      filtros.get('dataFinalInicioVigencia') &&
      filtros.get('dataFinalInicioVigencia').length == 10
    ) {
      let validValue = DateUtils.transform(
        filtros.get('dataFinalInicioVigencia'),
        'yy-mm-dd',
        'yy-mm-dd'
      );
      filter = addFilterUrl(filter, `dataFinalInicioVigencia=${validValue}`);
    }
    if (
      filtros.get('dataInicialVigenciaAtualizada') &&
      filtros.get('dataInicialVigenciaAtualizada').length == 10
    ) {
      let validValue = DateUtils.transform(
        filtros.get('dataInicialVigenciaAtualizada'),
        'yy-mm-dd',
        'yy-mm-dd'
      );
      filter = addFilterUrl(
        filter,
        `dataInicialVigenciaAtualizada=${validValue}`
      );
    }
    if (
      filtros.get('dataFinalVigenciaAtualizada') &&
      filtros.get('dataFinalVigenciaAtualizada').length == 10
    ) {
      let validValue = DateUtils.transform(
        filtros.get('dataFinalVigenciaAtualizada'),
        'yy-mm-dd',
        'yy-mm-dd'
      );
      filter = addFilterUrl(
        filter,
        `dataFinalVigenciaAtualizada=${validValue}`
      );
    }
    if (filtros.get('rateio')) {
      filter = this.addFilter(
        filter,
        `rateio=${filtros.get('rateio') ? 'S' : 'N'}`
      );
    }

    if (filtros.get('exercicioLicitacao')) {
      filter = this.addFilter(
        filter,
        `exercicioLicitacao=${filtros.get('exercicioLicitacao')}`
      );
    }

    if (this.refs.objeto && this.refs.objeto.getValue()) {
      filter = this.addFilter(filter, `objeto=${this.refs.objeto.getValue()}`);
    }

    if (
      this.refs.situacaoNoExercicioSelecionado &&
      this.refs.situacaoNoExercicioSelecionado.getValue()
    ) {
      filter = this.addFilter(
        filter,
        `situacaoNoExercicioSelecionado=${this.refs.situacaoNoExercicioSelecionado.getValue()}`
      );
    }

    if (filtros.get('contratosVigentes')) {
      filter = this.addFilter(
        filter,
        `contratosVigentes=${filtros.get('contratosVigentes')}`
      );
    }

    if (filtros.get('exercicioContrato')) {
      filter = this.addFilter(
        filter,
        `exercicioContrato=${filtros.get('exercicioContrato')}`
      );
    }

    return addPagination(page, filter);
  };

  onExporta = (exportType, openTab, windowParams) => {
    const { page, addErrorNotification } = this.props;
    const { apiURL } = configuration;

    if (page.get('content').size > 0) {
      const filter = this.montaFiltro(page);
      let filtro = filter + '&exportType=' + exportType;

      window.open(
        `${apiURL}/api/contratos/report?${filtro}`,
        openTab,
        windowParams
      );
    } else {
      addErrorNotification(
        'A consulta não apresentou resultado. Não é possível exportar para o formato selecionado!'
      );
    }
  };

  render() {
    const {
      tiposContrato,
      tiposLicitacao,
      downloadArquivo,
      page,
      filtros,
      location,
      isIntegradoOxy
    } = this.props;

    if (!page.has('content')) {
      return null;
    }

    const filter = this.montaFiltro(page);

    return (
      <section>
        <PageHeader location={this.props.location} />

        <NotasExplicativas pathname={this.props.location.pathname} />

        <Panel
          title="Consultar em Contratos / Atas"
          isForm
          ref="panelFiltroContratos"
        >
          <form>
            <Row>
              <Col xs={12}>
                <label
                  className="label filter-section-title"
                  style={contractSectionTitleStyle}
                >
                  <b className="module-color">Dados do contrato</b>
                </label>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={3} md={3}>
                <Input
                  name="tipoAto"
                  ref="tipoAto"
                  label="Tipo ato"
                  type="select"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('tipoAto')}
                >
                  <option value="">Selecione</option>
                  <option key={'Contrato'} value={1}>
                    Contrato
                  </option>
                  <option key={'Ata de Registro de Preços'} value={2}>
                    Ata de Registro de Preços
                  </option>
                </Input>
              </Col>
              <Col xs={12} sm={3} md={3}>
                <Input
                  name="tipoContrato"
                  ref="tipoContrato"
                  label="Tipo do Contrato"
                  type="select"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('tipoContrato')}
                >
                  <option value="">Selecione</option>
                  {tiposContrato.map(this.renderTiposContrato)}
                </Input>
              </Col>
              <Col xs={12} sm={3} md={3}>
                <Input
                  type="number"
                  ref="numeroContrato"
                  name="numeroContrato"
                  placeholder="Número do Contrato"
                  label="Número do Contrato"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('numeroContrato')}
                />
              </Col>
              <Col xs={12} sm={3} md={3}>
                <Input
                  type="number"
                  name="exercicioContrato"
                  placeholder="Ano contrato"
                  label="Ano contrato"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('exercicioContrato')}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={6} md={6}>
                <Input
                  type="text"
                  ref="nome"
                  name="nome"
                  placeholder="Nome do Contratado"
                  label="Nome do Contratado"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('nome')}
                />
              </Col>
              <Col xs={12} sm={6} md={6}>
                <Input
                  type="text"
                  ref="objeto"
                  name="objeto"
                  placeholder="Objeto"
                  label="Objeto"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('objeto')}
                />
              </Col>
            </Row>
            <hr className="mt-xs mb-xs" />
            <Row>
              <Col xs={12}>
                <label className="label filter-section-title">
                  <b className="module-color">Licitação</b>
                </label>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={4} md={4}>
                <Input
                  name="tipoLicitacao"
                  ref="tipoLicitacao"
                  label="Tipo da Licitação"
                  type="select"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('tipoLicitacao')}
                >
                  <option value="">Selecione</option>
                  {tiposLicitacao &&
                    tiposLicitacao.map(this.renderTiposLicitacao)}
                </Input>
              </Col>
              <Col xs={12} sm={4} md={4}>
                <Input
                  type="number"
                  ref="numeroLicitacao"
                  name="numeroLicitacao"
                  placeholder="Número da Licitação"
                  label="Número da Licitação"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('numeroLicitacao')}
                />
              </Col>
              <Col xs={12} sm={4} md={4}>
                <Input
                  type="number"
                  name="exercicioLicitacao"
                  placeholder="Ano licitação"
                  label="Ano licitação"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('exercicioLicitacao')}
                />
              </Col>
            </Row>
            <hr className="mt-xs mb-xs" />
            <Row>
              <Col
                xs={12}
                sm={12}
                md={4}
                data-period-filter-block
                style={periodFilterStyles.block}
              >
                <label
                  className="label"
                  data-period-filter-title
                  style={periodFilterStyles.title}
                >
                  <b className="module-color">Início da vigência</b>
                </label>
                <Row style={periodFilterStyles.range}>
                  <Col
                    xs={5}
                    data-period-filter-field
                    style={periodFilterStyles.field}
                  >
                    <DatePicker
                      id="dataInicialInicioVigencia"
                      name="dataInicialInicioVigencia"
                      ref="dataInicialInicioVigencia"
                      label=""
                      aria-label="Início da vigência: data inicial"
                      onChange={this.onChangeFiltro}
                      value={filtros.get('dataInicialInicioVigencia')}
                    />
                  </Col>
                  <Col
                    xs={2}
                    data-period-filter-separator
                    style={periodFilterStyles.separator}
                  >
                    até
                  </Col>
                  <Col
                    xs={5}
                    data-period-filter-field
                    style={periodFilterStyles.field}
                  >
                    <DatePicker
                      id="dataFinalInicioVigencia"
                      name="dataFinalInicioVigencia"
                      ref="dataFinalInicioVigencia"
                      label=""
                      aria-label="Início da vigência: data final"
                      onChange={this.onChangeFiltro}
                      value={filtros.get('dataFinalInicioVigencia')}
                    />
                  </Col>
                </Row>
              </Col>
              <Col
                xs={12}
                sm={12}
                md={4}
                data-period-filter-block
                style={periodFilterStyles.separatedBlock}
              >
                <label
                  className="label"
                  data-period-filter-title
                  style={periodFilterStyles.title}
                >
                  <b className="module-color">Final de vigência</b>
                </label>
                <Row style={periodFilterStyles.range}>
                  <Col
                    xs={5}
                    data-period-filter-field
                    style={periodFilterStyles.field}
                  >
                    <DatePicker
                      id="dataInicialVigenciaAtualizada"
                      name="dataInicialVigenciaAtualizada"
                      ref="dataInicialVigenciaAtualizada"
                      label=""
                      aria-label="Final de vigência: data inicial"
                      onChange={this.onChangeFiltro}
                      value={filtros.get('dataInicialVigenciaAtualizada')}
                    />
                  </Col>
                  <Col
                    xs={2}
                    data-period-filter-separator
                    style={periodFilterStyles.separator}
                  >
                    até
                  </Col>
                  <Col
                    xs={5}
                    data-period-filter-field
                    style={periodFilterStyles.field}
                  >
                    <DatePicker
                      id="dataFinalVigenciaAtualizada"
                      name="dataFinalVigenciaAtualizada"
                      ref="dataFinalVigenciaAtualizada"
                      label=""
                      aria-label="Final de vigência: data final"
                      onChange={this.onChangeFiltro}
                      value={filtros.get('dataFinalVigenciaAtualizada')}
                    />
                  </Col>
                </Row>
              </Col>
              <Col
                xs={12}
                sm={12}
                md={4}
                data-period-filter-block
                style={periodFilterStyles.separatedBlock}
              >
                <label
                  className="label"
                  data-period-filter-title
                  style={periodFilterStyles.title}
                >
                  <b className="module-color">Data da assinatura</b>
                </label>
                <Row style={periodFilterStyles.range}>
                  <Col
                    xs={5}
                    data-period-filter-field
                    style={periodFilterStyles.field}
                  >
                    <DatePicker
                      id="dataInicialAssinatura"
                      name="dataInicialAssinatura"
                      ref="dataInicialAssinatura"
                      label=""
                      aria-label="Data da assinatura: data inicial"
                      onChange={this.onChangeFiltro}
                      value={filtros.get('dataInicialAssinatura')}
                    />
                  </Col>
                  <Col
                    xs={2}
                    data-period-filter-separator
                    style={periodFilterStyles.separator}
                  >
                    até
                  </Col>
                  <Col
                    xs={5}
                    data-period-filter-field
                    style={periodFilterStyles.field}
                  >
                    <DatePicker
                      id="dataFinalAssinatura"
                      name="dataFinalAssinatura"
                      ref="dataFinalAssinatura"
                      label=""
                      aria-label="Data da assinatura: data final"
                      onChange={this.onChangeFiltro}
                      value={filtros.get('dataFinalAssinatura')}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <hr className="mt-xs mb-xs" />
            <Row>
              <Col xs={12}>
                <label className="label filter-section-title">
                  <b className="module-color">Situação e opções</b>
                </label>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={6} md={4}>
                <Input
                  name="situacaoNoExercicioSelecionado"
                  ref="situacaoNoExercicioSelecionado"
                  label="Situação no Ano Selecionado"
                  type="select"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('situacaoNoExercicioSelecionado')}
                >
                  <option value="">Selecione</option>
                  <option key={'Encerrado'} value={'Encerrado'}>
                    Encerrado
                  </option>
                  <option key={'Rescindido'} value={'Rescindido'}>
                    Rescindido
                  </option>
                  <option key={'Suspenso'} value={'Suspenso'}>
                    Suspenso
                  </option>
                  <option key={'Vigente'} value={'Vigente'}>
                    Vigente
                  </option>
                </Input>
              </Col>
              <Col
                xs={12}
                sm={6}
                md={3}
                data-option-checkbox
                style={optionCheckboxStyle}
              >
                <label className="label"></label>
                <Input
                  label="Contratos Vigentes Atualmente"
                  type="checkbox"
                  name="contratosVigentes"
                  onChange={this.onChangeFiltro}
                  checked={filtros.get('contratosVigentes')}
                  value={filtros.get('contratosVigentes')}
                />
              </Col>
              {this.showRateio() && (
                <Col
                  xs={12}
                  sm={6}
                  md={2}
                  data-option-checkbox
                  style={optionCheckboxStyle}
                >
                  <label className="label"> </label>
                  <Input
                    type="checkbox"
                    ref="rateio"
                    name="rateio"
                    placeholder="Contrato de Rateio"
                    label="Rateio"
                    onChange={this.onChangeFiltro}
                    value={filtros.get('rateio')}
                  />
                </Col>
              )}
              <Col xs={12} sm={6} md={3} mdOffset={this.showRateio() ? 0 : 2}>
                <FilterButtons
                  onConsulta={this.onConsultaContratos}
                  onReset={this.onResetFiltro}
                />
              </Col>
            </Row>
          </form>
        </Panel>

        <Panel isForm tableResponsive scrollX expansible={false}>
          <Row>
            <Col xs={6}>
              <UltimaAtualizacao modulo="10" tipo="contrato" />
            </Col>
            <Col xs={6}>
              <ExportButtonGroup onClick={this.onExporta} visible={true} />
            </Col>
          </Row>
          <ContratoListagem
            filter={filter}
            contratosPage={page}
            onDownload={downloadArquivo}
            searchWithPage={this.searchWithPage}
            pathname={location.pathname}
            history={this.props.history}
            isIntegradoOxy={isIntegradoOxy}
            textoSemRegistro="A entidade não possui Contratos/Atas em aberto no momento."
          />
        </Panel>

        <SearchPagination page={page} searchWithPage={this.searchWithPage} />
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    page: state.contrato.get('contratos'),
    uf: state.entidade.getIn(['entidadeSelecionada', 'uf']),
    tiposContrato: state.contrato.get('tiposContrato'),
    tiposLicitacao: state.licitacao.get('modalidades'),
    filtros: state.crud.getIn(['filtroContratos', 'currentRecord'], Map({})),
    isIntegradoOxy: state.entidade.getIn([
      'configuracoesGerais',
      'isIntegradoOxy'
    ]),
    parametrosPadraoExercicio: state.contrato.get('parametrosPadraoExercicio')
  };
}

const allActions = {
  ...actions,
  loadModalidades,
  downloadArquivo,
  onChange,
  resetCrud,
  addErrorNotification
};

export default connect(mapStateToProps, allActions)(FormContrato);
